var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.timetable)?_c('div',[(_vm.timetable.type == 'sections')?_c('div',[_c('select-tickets-sections')],1):_vm._e(),_vm._v(" "),(_vm.timetable.type == 'pricegroups')?_c('div',[_c('select-tickets-pricegroups')],1):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }